// extracted by mini-css-extract-plugin
export default {"resultTxt":"InflationTracker_resultTxt__UAO4r"};